import { Post } from "@forcode/domain";
import { PostCard } from "../../organism";
import css from "./PostGridTemplate.module.css";

export interface PostGridTemplateProps {
  posts: Post[];
}

const BASE_CLASS = "f-PostGridTemplate";

const AdInFeed = () => (
  <article className={css[`${BASE_CLASS}-post`]}>
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-format="fluid"
      data-ad-layout-key="-66+c1-2d-6e+11q"
      data-ad-client="ca-pub-7090963340374762"
      data-ad-slot="6777723426"
    ></ins>
  </article>
);

const PostArticle = ({ post }: { post: Post }) => (
  <article className={css[`${BASE_CLASS}-post`]}>
    <PostCard post={post} />
  </article>
);

export const PostGridTemplate = ({ posts }: PostGridTemplateProps) => {
  return (
    <section className={css[BASE_CLASS]}>
      {posts
        .map((post, idx) => [
          idx > 0 && idx % 6 === 0 && <AdInFeed key={`ad-${idx}`} />,
          <PostArticle post={post} key={`${post.slug}-${idx}`} />,
        ])
        .filter(Boolean)}
      {/* {posts.map((post, idx) => (
        <article
          className={css[`${BASE_CLASS}-post`]}
          key={`${post.slug}-${idx}`}
        >
          <PostCard post={post} />
        </article>
      ))} */}
    </section>
  );
};
